import { RESPONSE_TYPE } from "../const/vote";
import { ApiIQuestion } from "../domain/election";
import { BASIC_TEXT } from "./basic_text/basic-text-typedef";
import { CHECK_LIST } from "./check_list/check-list-typedef";
import { PREFERENCE } from "./preference/preference-typedef";
import { YES_NO } from "./yes_no/yes-no-typedef";

export const initialValueMux = (ballot: ApiIQuestion) => {
    const { response_type } = ballot;
    switch (response_type) {
        case RESPONSE_TYPE.PREFERENCE:
            return PREFERENCE.INITIAL_VALUE;

        case RESPONSE_TYPE.CHECK_LIST:
            return CHECK_LIST.INITIAL_VALUE;

        case RESPONSE_TYPE.YES_NO:
            return YES_NO.INITIAL_VALUE;

        case RESPONSE_TYPE.BASIC_TEXT:
            return BASIC_TEXT.INITIAL_VALUE;
    }
}